export default "__VITE_ASSET__DbD7kGGs__"